import React, { memo, useCallback } from 'react'

import { Button, Icon, Search, ImageAdd, Edit } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { openImageAssistant } from 'Pods/ThreeDStudio/Store/actions/ui'
import { IMAGE_ASSISTANT_TAB } from 'Pods/ThreeDStudio/Store/constants'

const searchIcon = <Icon svgComponent={Search} size={iconSize} notSpaced />
const createIcon = <Icon svgComponent={ImageAdd} size={iconSize} notSpaced />
const editIcon = <Icon svgComponent={Edit} size={iconSize} notSpaced />

function IdeationActions() {
  const hasInputImage = useThreeDStudioStore(state => !!state.modelSettings.inputImage)

  const handleSearch = useCallback(() => openImageAssistant(IMAGE_ASSISTANT_TAB.SEARCH), [])
  const handleCreate = useCallback(() => openImageAssistant(IMAGE_ASSISTANT_TAB.CREATE), [])
  const handleEdit = useCallback(() => openImageAssistant(IMAGE_ASSISTANT_TAB.EDIT), [])

  return (
    <div className="image-uploader__ideation-actions">
      <Button
        type="secondary"
        size="small"
        variant="with-icon"
        customClass="image-uploader__ideation-button"
        icon={searchIcon}
        onClick={handleSearch}
      >
        <span className="image-uploader__ideation-button-label">Search Image</span>
      </Button>
      <Button
        type="secondary"
        size="small"
        variant="with-icon"
        customClass="image-uploader__ideation-button"
        icon={createIcon}
        onClick={handleCreate}
      >
        <span className="image-uploader__ideation-button-label">Create Image</span>
      </Button>
      <Button
        type="secondary"
        size="small"
        variant="with-icon"
        customClass="image-uploader__ideation-button"
        icon={editIcon}
        onClick={handleEdit}
        disabled={!hasInputImage}
      >
        <span className="image-uploader__ideation-button-label">Edit Image</span>
      </Button>
    </div>
  )
}

export default memo(IdeationActions)
